import styled from 'styled-components';

export const Wrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.black2};
  cursor: pointer;
`;
